import Lottery from '../service/lottery'
import RequestUtils from '../../store/requestUtils'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getlotterys(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Lottery.getlotterys(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getlottery(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Lottery.getlottery(payload), {
        type: 'info',
        success,
        fail
      })
    },
    addlottery(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Lottery.addlottery(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatelottery(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Lottery.updatelottery(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deletelottery(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Lottery.deletelottery(payload), {
        type: 'action',
        success,
        fail
      })
    },
    publishlottery(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Lottery.publishlottery(payload), {
        type: 'action',
        success,
        fail
      })
    },
    closelottery(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Lottery.closelottery(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getwinningrecords(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Lottery.getwinningrecords(payload), {
        type: 'list',
        success,
        fail
      })
    }
  }
}
